import script from "./footer-component.vue?vue&type=script&setup=true&lang=js"
export * from "./footer-component.vue?vue&type=script&setup=true&lang=js"

import "./footer-component.vue?vue&type=style&index=0&id=6a9171d0&lang=scss"

const __exports__ = script;

export default __exports__